import { useState } from "react";
import { Box, Button, Hidden, Typography } from "@material-ui/core";
import "./BookScreenBanner.css";
import { Link } from "react-router-dom";
import leftArrow from "../../../assets/icons/leftArrow.png";
import textIcon from "../../../assets/icons/noun_Text Size_3557859.png";
import User from "../../../interfaces/User";
import UserSettings from "../../../interfaces/UserSettings";
import ProfileDrawer from "../../StudentHeader/ProfileDrawer";
import Shiitake from "shiitake";

interface BookScreenBannerProps {
  title: string;
  totalWords: number;
  uniqueWords: number;
  currentUser: User;
  currentUserSettings: UserSettings;
}

const BookScreenBanner = (props: BookScreenBannerProps) => {
  const [state, setState] = useState({
    profileOpen: false,
  });

  const profileButtonHandler = () => {
    setState(state => {
      return {
        ...state,
        profileOpen: !state.profileOpen,
      };
    });
  };
  return (
    <div>
      <Box height="40px" className="topBanner">
        <div className="topLeftText">
          <Link to="/Home">
            <img className="leftArrow" alt="Return Home" src={leftArrow} />
          </Link>
          <Typography className="headerTextLeft" component="div">
            <Shiitake lines={1}>{props.title}</Shiitake>
          </Typography>
        </div>

        <div className="rightLayoutText">
          {props.totalWords !== 0 && (
            <Hidden smDown>
              <Typography className="headerTextRight">
                {props.totalWords + " Words | " + props.uniqueWords + " Unique"}
              </Typography>
            </Hidden>
          )}
          <Button onClick={profileButtonHandler}>
            <img src={textIcon} alt="Text" className="textIcon" />
          </Button>
        </div>
      </Box>
      <ProfileDrawer onClose={profileButtonHandler} onOpen={profileButtonHandler} open={state.profileOpen} />
    </div>
  );
};
export default BookScreenBanner;
